import store from '@/api/modules/store'
import outletPrice from '@/api/modules/outletprice'
import global from '@/api/modules/global'
import item from '@/api/modules/item'
import menuGroup from '@/api/modules/menugroup'
import menuItem from '@/api/modules/menuitem'
import menuGroupLimit from '@/api/modules/menugrouplimit'
import menuPrice from '@/api/modules/menuprice'
import menuItemLimit from '@/api/modules/menuitemlimit'
import modifierItem from '@/api/modules/modifieritem'
import saleMenuSchedule from '@/api/modules/salemenuschedule'
import menuGroupSchedule from '@/api/modules/menuGroupSchedule'
import modifierPrice from '@/api/modules/modifierprice'
import storeDeliverySchedule from '@/api/modules/storedeliveryschedule'
import storeOpenSchedule from '@/api/modules/storeopenschedule'
import storeGeofence from '@/api/modules/storegeofence'
import orderReport from '@/api/modules/orderreport'
import generalData from '@/api/modules/generaldata'
import downloadOrders from '@/api/modules/downloadOrders'
import feeCalculationSetting from '@/api/modules/feeCalculationSetting'
import deliverySetting from '@/api/modules/deliverySetting'
import billListOrder from '@/api/modules/billListOrder'
import menuUpload from '@/api/modules/menuUpload'
import menuVariant from '@/api/modules/menuvariant'
import posOrder from '@/api/modules/posOrder'
import salesSummary from '@/api/modules/salesSummary'
import merchantConfig from '@/api/modules/merchantConfig'
import waitingData from '@/api/modules/waitingData'
import customerUpload from '@/api/modules/customerUpload'
import reviewManagement from '@/api/modules/reviewManagement'
import merchantStaff from '@/api/modules/merchantStaff'
import posOrderInput from '@/api/modules/posOrderInput'
import customer from '@/api/modules/customer'
import messageGroup from '@/api/modules/messageGroup'

const api = {
  ...store,
  ...outletPrice,
  ...global,
  ...item,
  ...menuGroup,
  ...menuItem,
  ...menuPrice,
  ...menuItemLimit,
  ...menuGroupLimit,
  ...modifierPrice,
  ...storeDeliverySchedule,
  ...modifierItem,
  ...menuGroupSchedule,
  ...saleMenuSchedule,
  ...storeOpenSchedule,
  ...storeGeofence,
  ...orderReport,
  ...generalData,
  ...downloadOrders,
  ...feeCalculationSetting,
  ...deliverySetting,
  ...billListOrder,
  ...menuUpload,
  ...menuVariant,
  ...posOrder,
  ...salesSummary,
  ...merchantConfig,
  ...waitingData,
  ...customerUpload,
  ...reviewManagement,
  ...merchantStaff,
  ...posOrderInput,
  ...customer,
  ...messageGroup
}
export default api
